import { Episodes, ProductRelated, Seasons, Series, Vods } from '@/shared/libs/sdk';
import { ErrorCode, ProductType } from '@/shared/enums';

export default {
  data() {
    return {
      bookmarks: this.$services.resolve('bookmarks'),
      subscriber: this.$services.resolve('subscriber'),
      relatedPrograms: undefined,
      relatedClips: undefined,
    };
  },
  methods: {
    fetchProduct(serialId) {
      const { id, type } = this.$route.params;
      const productId = type?.toUpperCase() === ProductType.SERIAL ? id : serialId;
      const series = new Series();
      if (this.product && this.product.id === productId) {
        return Promise.resolve();
      }

      return series.fetch(productId).then(() => {
        this.product = series.get(productId);
      });
    },
    fetchSeasonList() {
      this.seasons = new Seasons({ id: this.product.id, sortType: this.product.sortType });
      return this.seasons.fetchAll();
    },
    fetchEpisode(id) {
      this.episodes = new Episodes({ sortType: this.product?.sortType });

      if (id) {
        return this.episodes.fetch(id, { force: true }).catch(() => {});
      }
    },
    fetchClip(id) {
      if (!id) {
        return;
      }

      this.clips = new Vods();

      return this.clips.fetch(id)
        .then(() => this.clips.get(id))
        .catch(() => Promise.reject(ErrorCode.CLIP_NOT_AVAILABLE));
    },
    loadSerialData({ serialId, episodeId, clipId } = {}) {
      return Promise.resolve()
        .then(() => this.fetchProduct(serialId))
        .then(() => this.fetchSeasonList())
        .then(() => this.fetchEpisode(episodeId))
        .then(() => this.fetchClip(clipId));
    },
    getDefaultEpisode() {
      if (this.forceToShowFirstEpisode) {
        this.forceToShowFirstEpisode = false;
        return Promise.resolve(this.episodes.collection.first);
      }

      if (this.subscriber.isLogged) {
        return this.bookmarks.getContinueWatchingEpisode(this.product.id);
      }

      const playableEpisode = this.episodes.collection.records.find((episode) => {
        if (episode.displaySchedules) {
          return !episode.displaySchedules.find((schedule) => schedule.type === 'SOON');
        }

        return true;
      });

      if (playableEpisode) {
        if (!this.product.autoplay) {
          this.loaded = true;
          this.$spinner.hide();
        }
        return Promise.resolve(playableEpisode);
      }

      return Promise.resolve(this.episodes.collection.first);
    },
    getLastBookmark() {
      let bookmarks = this.bookmarks.collection.records.filter((item) => {
        return item.type === ProductType.EPISODE && item.season?.serial.id === this.product.id;
      });

      bookmarks = bookmarks.sort((a, b) => {
        return b.bookmark.modifiedAt.valueOf() - a.bookmark.modifiedAt.valueOf();
      });

      return bookmarks[0];
    },
    setSeason({ episodeId }) {
      let season;
      const bookmark = !episodeId && this.getLastBookmark();

      if (bookmark) {
        season = this.seasons.get(bookmark.season.id);
      } else {
        season = episodeId
          ? this.seasons.get(this.episode.season.id)
          : this.seasons.collection.first;
      }

      if (this.season && this.season.number === season.number) {
        this.updateCurrentEpisode();
      }

      this.season = season;
      this.episodes.season = this.season;
    },
    async updateCurrentEpisode() {
      if (!this.episode) {
        this.episode = await this.getDefaultEpisode().catch(() => {});
      }
    },
    getSeasonEpisodes() {
      if (!this.season) {
        return;
      }

      this.product.season = this.season;
      this.season.serial = this.product;
      this.episodes.season = this.season;
      this.episodes.fetchAll('', {
        serialId: this.product.id,
        seasonId: this.season.id,
        reset: true,
      }).then(() => {
        return this.updateCurrentEpisode();
      });
    },
    fetchRelatedClips(product) {
      this.relatedClips = new ProductRelated(product, ProductType.CLIP);
      return this.relatedClips.fetchAll('', { params: { maxResults: 100 } })
        .catch(() => {});
    },
    fetchRelatedPrograms(product) {
      this.relatedPrograms = new ProductRelated(product, ProductType.PROGRAMME);
      return this.relatedPrograms.fetchAll('', { params: { maxResults: 100 } })
        .catch(() => {});
    },
    getSeriesRelated() {
      if (!this.seasons) {
        return;
      }

      return Promise.all([
        this.fetchRelatedClips(this.seasons),
        this.fetchRelatedPrograms(this.seasons),
      ]);
    },
    getSeasonRelated() {
      if (!this.season) {
        return;
      }

      return Promise.all([
        this.fetchRelatedClips(this.season),
        this.fetchRelatedPrograms(this.season),
      ]);
    },
    getEpisodeRelated() {
      if (!this.episode) {
        return;
      }

      return Promise.all([
        this.fetchRelatedClips(this.episode),
        this.fetchRelatedPrograms(this.episode),
      ]);
    },
  },
};
